<app-popup-layout #modal class="d-none d-md-block">
    <div class="modal-container min-h-full">
      <img
        (click)="modal.close()"
        class="help-screen-close-button ms-auto me-xl-n5"
        src="/assets/svg/model-close-btn.svg"
        alt="close"
      />
    
      <img src="assets/svg/reward-points.svg" class="w-3/5" alt="Succesful Voucher Generation" /> 
      <span class="points vertical-rows">  <img src="assets/svg/enkash-rewards-currency.svg" alt="Points" class="h-12 pe-2"> {{ balance | number : '1.0-0' }}  </span>

      <p class="font-size-14 font-medium text-center mt-24">
        You have <strong> <img src="assets/svg/enkash-credit.svg" alt="Rupee" class="w-6"> {{ balance | number : '1.0-0' }} </strong> EnKash points available.
      </p>

      <p class="font-size-14 font-medium text-center mt-2">
        Redeem your points to buy brand vouchers <br> across 400+ brands like Amazon, Flipkart, Swiggy, Myntra and more.
      </p>

      <p class="font-size-10 font-medium text-center my-4"> <img src="assets/svg/points.svg" alt="Points" class="h-8 px-2"> 1 Point = <img src="assets/svg/rupee.svg" alt="Rupee" class="w-4"> 1 </p>

      <button mat-flat-button color="primary" class="cards-primary-submit d-block text-center mt-2" (click)="redeemVouchers(); modal.close()" [disabled]="isBlockedOrLockedCardFlag">
        Redeem Now
      </button>

    </div>
</app-popup-layout>

<div class="d-block d-md-none">
  <app-action-sheet-controller [isVisible]="true" [overlay]="false" [noHeader]="false">
    <ng-container *ngTemplateOutlet="successPopup"></ng-container>
  </app-action-sheet-controller>
</div>
<ng-template #successPopup>
  <div class="modal-container">
    <img
      (click)="modal.close()"
      class="help-screen-close-button ms-auto me-xl-n5"
      src="/assets/svg/model-close-btn.svg"
      alt="close"
    />
  
    <img src="assets/svg/reward-points.svg" class="w-auto" alt="Succesful Voucher Generation" /> 
    <span class="points-mobile vertical-rows">  <img src="assets/svg/enkash-rewards-currency.svg" alt="Points" class="h-12 pe-2"> {{ balance | number : '1.0-0' }}  </span>

    <p class="font-size-14 font-medium text-center mt-24">
      You have <strong> {{ balance | number : '1.0-0' }} </strong> EnKash points available.
    </p>

    <p class="font-size-14 font-medium text-center mt-2">
      Redeem your points to buy brand vouchers <br> across 400+ brands like Amazon, Flipkart, Swiggy, Myntra and more.
    </p>

    <p class="font-size-10 font-medium text-center my-4"> <img src="assets/svg/points.svg" alt="Points" class="h-8 px-2"> 1 Point = <img src="assets/svg/rupee.svg" alt="Rupee" class="w-4"> 1 </p>

    <button mat-flat-button color="primary" class="cards-primary-submit d-block text-center mt-2" (click)="redeemVouchers(); modal.close()" [disabled]="isBlockedOrLockedCardFlag">
      Redeem Now
    </button>

  </div>
</ng-template>